module.exports = __webpack_public_path__ + "img/Metastasis-CRC_GSE206552.a7e05541.png";